import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./Header";
import Footer from "./Footer";
import MobileBottomNav from "./MobileBottomNav";
import AIAssistant from "./AIAssistant";
import YedaGuide from "./YedaGuide";
import ScrollToTop from "./ScrollToTop";
import CjCartFab from "./market/CjCartFab";

export const Layout = () => {
  const { pathname } = useLocation();
  // Immersive live-room routes (/live/{id}, /live/stage/{id}) hide the global bottom nav +
  // floating widgets so they never overlap the host media control bar. The /live list stays normal.
  const immersive = /^\/live\/[^/]+/.test(pathname);
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {!immersive && <MobileBottomNav />}
      {!immersive && <YedaGuide />}
      {!immersive && <CjCartFab />}
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default Layout;
